export default __webpack_public_path__ + "static/media/img_404.312113be.svg";